













































import { computed, defineComponent } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import config from "@/config";
import { AttachmentFile } from "@/types";
import AttachmentFilesPreview from "@/components/AttachmentFilesPreview";
import AttachmentPriceSetting from "@/components/AttachmentPriceSetting";
import BaseIcon from "@/components/BaseIcon";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "MessageEditorView",
  components: { AttachmentFilesPreview, AttachmentPriceSetting, BaseInputTextarea, BaseIcon, BaseSpinner },
  props: {
    files: { type: Array as () => AttachmentFile[], required: true },
    packageList: { type: Array as () => PaymentPackage[], required: true },
    attachmentPriceId: { type: String, required: true },
    uploadingAttachment: { type: Boolean, default: false },
    placeholder: { type: String, default: "" },
    value: { type: String, default: "" },
    loading: { type: Boolean, required: true },
    canSendAttachment: { type: Boolean, default: true },
  },
  setup(props, { emit }) {
    const isNoPrice = computed(() => props.attachmentPriceId === "0");
    const isShowPriceSetting = computed(() => props.packageList.length > 0 && props.files.length > 0);

    const maxPrivateAttachmentWithoutTeaser = computed(() => {
      if (isNoPrice.value) {
        return config.attachments.MAX_FILES_UPLOAD_FOR_CREATOR - props.files.length;
      } else {
        const privateFilesCount = props.files.filter(f => !f.publicAccess).length;
        return config.attachments.MAX_FILES_UPLOAD_FOR_CREATOR - privateFilesCount;
      }
    });

    const uploadAttachment = () => {
      if (maxPrivateAttachmentWithoutTeaser.value > 0) {
        emit("uploadAttachment");
      }
    };

    return {
      uploadAttachment,
      isShowPriceSetting,
      isNoPrice,
      maxPrivateAttachmentWithoutTeaser,
    };
  },
});
